import type React from "react";

import { useState } from "react";
import { Search } from "lucide-react";

import {
  ClearButton,
  ContentContainer,
  EmptyState,
  Header,
  PageContainer,
  ResultCard,
  ResultsContainer,
  ResultsList,
  ResultsTitle,
  ResultSummary,
  ResultTitle,
  SearchButton,
  SearchForm,
  SearchIcon,
  SearchInput,
  SearchInputWrapper,
  Subtitle,
  Title,
} from "./Home.styles";
import AudioPlayer from "components/audio-player";
import searchQueryAPI from "hooks/api-calls";

export default function AudioSearch() {
  const [query, setQuery] = useState("");
  const [resultQuery, setResultQuery] = useState("");
  const [results, setResults] = useState<any[]>([]);
  const [isSearching, setIsSearching] = useState(false);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!query.trim()) return;

    setIsSearching(true);
    searchQueryAPI(query)
      .then((data) => {
        setResults(data?.results);
        setResultQuery(query);
      })
      .catch((err) => {
        console.log("🚀 ~ searchQueryAPI ~ err:", err);
      })
      .finally(() => {
        setIsSearching(false);
      });
  };
  function mmssToSeconds(time: string) {
    const [minutes, seconds] = time.split(":").map(Number);
    return minutes * 60 + seconds;
  }

  return (
    <PageContainer>
      <ContentContainer>
        <Header>
          <img
            src="/logo.svg"
            alt="Logo"
            style={{
              height: "60px",
              marginRight: "15px",
              marginBottom: "10px",
            }}
          />
          <div>
            <Title>Audio Search</Title>
            <Subtitle>
              Search for audio content and play the most relevant sections
            </Subtitle>
          </div>
        </Header>

        <SearchForm onSubmit={handleSearch}>
          <SearchInputWrapper>
            <SearchIcon>
              <Search size={16} />
            </SearchIcon>
            <SearchInput
              type="text"
              placeholder="Search for audio content..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </SearchInputWrapper>
          <SearchButton type="submit" disabled={isSearching}>
            {isSearching ? "Searching..." : "Search"}
          </SearchButton>
          {results.length > 0 && (
            <ClearButton
              onClick={() => {
                setQuery("");
                setResults([]);
                setResultQuery("");
              }}
            >
              Clear
            </ClearButton>
          )}
        </SearchForm>

        {results.length > 0 ? (
          <ResultsContainer>
            <ResultsTitle>Results for "{resultQuery}"</ResultsTitle>
            <ResultsList>
              {results.map((result) => (
                <ResultCard key={result.segmentId}>
                  <ResultTitle>
                    {result.fileName + " - " + result.seg_topic}
                  </ResultTitle>
                  <ResultSummary>{result.summary}</ResultSummary>
                  <AudioPlayer
                    audioUrl={result.filePath}
                    highlightStart={result.start}
                    highlightEnd={result.end}
                    duration={mmssToSeconds(result.duration)}
                  />
                </ResultCard>
              ))}
            </ResultsList>
          </ResultsContainer>
        ) : (
          <EmptyState>
            {query
              ? isSearching
                ? "Searching..."
                : "No results found"
              : "Enter a search term to find related audio content"}
          </EmptyState>
        )}
      </ContentContainer>
    </PageContainer>
  );
}
